export const environment = {
  production: true,
  hmr: false,
  apiUrl: "/services/mcresidus",
  apiRetries: 12,
  apiCacheSize: 1000,
  geoUrl: "/services/georest",
  geoBCNUrl: "https://w33.bcn.cat/geoBCN/serveis",
  sentry_dsn: "https://44f6e32eb3ae427c85a88368b99acf3a@sentry.dtibcn.cat/11",
  loginURL: "https://idp-int.ajuntament.bcn/auth/realms/corp/protocol/openid-connect/auth",
  tokenURL: "https://idp-int.ajuntament.bcn/auth/realms/corp/protocol/openid-connect/token",
  xIbmClientId: "5dfece3d70ceb4af1ca93ccde5b46e1a",
  clientId: "mcresidus--spa--front",
  scopes: "openid mcresidus--api--mcresidus--back mcresidus--spa--front",
  openidConfiguration: "https://idp-int.ajuntament.bcn/auth/realms/corp/.well-known/openid-configuration",
  issuer: "https://idp-int.ajuntament.bcn/auth/realms/corp",
  token_endpoint: "https://idp-int.ajuntament.bcn/auth/realms/corp/protocol/openid-connect/token",
  check_session_iframe: "https://idp-int.ajuntament.bcn/auth/realms/corp/protocol/openid-connect/login-status-iframe.html",
  end_session_endpoint: "https://idp-int.ajuntament.bcn/auth/realms/corp/protocol/openid-connect/logout",
  authorization_endpoint: "https://idp-int.ajuntament.bcn/auth/realms/corp/protocol/openid-connect/auth",
  introspection_endpoint: "https://idp-int.ajuntament.bcn/auth/realms/corp/protocol/openid-connect/token/introspect",
  userinfo_endpoint: "https://idp-int.ajuntament.bcn/auth/realms/corp/protocol/openid-connect/userinfo",
  registration_endpoint: "https://idp-int.ajuntament.bcn/auth/realms/corp/clients-registrations/openid-connect",
  revocation_endpoint: "https://idp-int.ajuntament.bcn/auth/realms/corp/protocol/openid-connect/revoke",
};
